import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FeatureGuardFacade } from './feature-guard.facade';
import { FeaturesGuardModel } from './feature-guard.model';

@Injectable({
  providedIn: 'root',
})
export class FeatureGuardGuard {
  constructor(
    private router: Router,
    private model: FeaturesGuardModel,
    private facade: FeatureGuardFacade,
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    const thisFeature = route.data.feature;

    return this.facade.checkFeatureAvailability(thisFeature).pipe(
      map(result => {
        if (result) return result;
        const redirectUrl = this.model.data[thisFeature].upgradeUrl;
        if (redirectUrl) this.router.navigateByUrl(redirectUrl);
        return false;
      }),
    );
  }
}
